/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Consumption_Sub_Meters_Exceed_AlertInputs */



/**
* | output |
* | --- |
* | "The sub-meters exceed the main meter by {value}." |
*
* @param {Consumption_Sub_Meters_Exceed_AlertInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_sub_meters_exceed_alert = /** @type {((inputs: Consumption_Sub_Meters_Exceed_AlertInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Sub_Meters_Exceed_AlertInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`The sub-meters exceed the main meter by ${i?.value}.`)
	return /** @type {LocalizedString} */ (`Les sous-compteurs dépassent le compteur principal de ${i?.value}.`)
});